import { api } from './api';
import { getParams } from 'utils';

export const fetchReports = (query) => {
  const params = getParams(query);
  return api.get('/report/template', params);
};

export const fetchDefaultReports = (query) => {
  const params = getParams(query);
  return api.get('/report/template/default', params);
};

export const fetchReportById = (id) => {
  return api.get(`/report/template/${id}`);
};

export const deleteReportById = (id) => {
  return api.delete(`/report/template/${id}`);
};

export const sendReportToRequesterById = (id) => {
  return api.post(`/report/template/${id}/request`);
};

export const createReport = (payload) => {
  return api.post('/report/template', payload);
};

export const updateReport = (id, payload) => {
  return api.put(`/report/template/${id}`, payload);
};

export const fetchReportToken = () => {
  return api.get('/report/token');
};

export const downloadReport = (id, report_ts) => {
  return api.get(`/report/result/${id}/report_ts/${report_ts}`);
};
